import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { TablePlugin as LexicalTablePlugin } from '@lexical/react/LexicalTablePlugin';
import {
  $createTableNodeWithDimensions,
  INSERT_TABLE_COMMAND,
  TableNode,
} from '@lexical/table';
import { $insertNodes, COMMAND_PRIORITY_EDITOR } from 'lexical';
import { useEffect } from 'react';

import TableActionMenuPlugin from '../../rich-lexical-editor/plugins/TableActionMenuPlugin';
import TableCellResizerPlugin from '../../rich-lexical-editor/plugins/TableCellResizerPlugin';

export type InsertTableCommandPayload = Readonly<{
  columns: string;
  rows: string;
  includeHeaders?: boolean;
}>;

export { INSERT_TABLE_COMMAND };

export function TablePlugin(): JSX.Element {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([TableNode])) {
      throw new Error('TablePlugin: TableNode not registered on editor');
    }

    return editor.registerCommand<InsertTableCommandPayload>(
      INSERT_TABLE_COMMAND,
      ({ columns, rows, includeHeaders }) => {
        const tableNode = $createTableNodeWithDimensions(
          Number(rows),
          Number(columns),
          includeHeaders ?? true
        );
        $insertNodes([tableNode]);

        const firstDescendant = tableNode.getFirstDescendant();
        if (firstDescendant) {
          firstDescendant.selectStart();
        }

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return (
    <>
      <LexicalTablePlugin hasCellMerge={true} hasCellBackgroundColor={false} />
      <TableCellResizerPlugin />
      <TableActionMenuPlugin />
    </>
  );
}

export default TablePlugin;
